import { defineStore } from 'pinia';
import { ref } from 'vue'

export const useThemeStore = defineStore('theme', () => {

   const theme = ref('light')

   function setCurrentTheme() {
      localStorage.setItem('theme', theme.value);
   }

   function toggleTheme() {
      theme.value = theme.value === 'light' ? 'dark' : 'light';
      setCurrentTheme()
      initTheme()
   }

   function initTheme() {
      if (window.isDarkTheme) {
         const isSystemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
         if (isSystemDark) 
            theme.value = 'dark'
      }
      // theme.value = localStorage.getItem('theme') || 'light';
      if (theme.value === 'dark') {
         document.body.classList.add('dark-theme');
         document.body.style.setProperty('--data_color_additional_text', 'var(--app_color_additional_dark)');
         document.body.style.setProperty('--data_subcomments_button', 'var(--app_subcomments_button_dark)');
         document.body.style.setProperty('--data__common_behind_color', 'var(--app_choice_button_dark)');
         document.body.style.setProperty('--app_text_color', 'var(--app_color_light)');
         document.body.style.setProperty('--data_rating_graph_background', 'var(--app_rating_graph_background_dark)');
         document.body.style.setProperty('--data_answer_container_background', 'var(--app_answer_container_background_dark)');
         document.body.style.setProperty('--data_color_additional_border', 'var(--app_color_border_dark)');
         document.body.style.setProperty('--data_star_bg_color', 'var(--app_star_bg_color_dark)');
      } else {
         document.body.classList.remove('dark-theme');
         document.body.style.setProperty('--data_color_additional_text', 'var(--app_color_additional_light)');
         document.body.style.setProperty('--data__common_behind_color', 'var(--app_choice_button_light)');
         document.body.style.setProperty('--data_subcomments_button', 'var(--app_subcomments_button_light)');
         document.body.style.setProperty('--app_text_color', 'var(--app_color_dark)');
         document.body.style.setProperty('--data_rating_graph_background', 'var(--app_rating_graph_background_light)');
         document.body.style.setProperty('--data_answer_container_background', 'var(--app_answer_container_background_light)');
         document.body.style.setProperty('--data_color_additional_border', 'var(--app_color_border_light)');
         document.body.style.setProperty('--data_star_bg_color', 'var(--app_star_bg_color_light)');
      }
      document.body.className = (theme.value === 'light' ? 'dark' : 'light') + "-theme";
   }

   // initTheme()

   // function toggleTheme() {
   //    theme.value = theme.value === 'light_theme' ? 'dark_theme' : 'light_theme';
   //    setCurrentTheme()
   // }

   return { theme, toggleTheme, initTheme }
});